<template>
    <div>
        <div class="row pxo-3 mbo-3">
            <div class="col-6 text-uppercase">
                Available Balance
            </div>
            <div class="col-6 text-right font-weight-bold">
                <span> {{ wallet.baseBalance }} {{ tokenText }} </span>
            </div>
        </div>

        <div>
            <div class="input-group input-group-outline mbo-3 flex-nowrap">
                <span class="wrap-input-placeholder">
                    {{ tokenText }}
                </span>
                <input
                    type="number"
                    class="form-control mto-1 text-right wrap-form-input"
                    aria-label="Wrap"
                    aria-describedby="basic-addon2"
                    v-model="wrapInput"
                    id="wrap-input-from"
                    min="0"
                    @keypress="isNumber($event)"
                />
                <div class="input-group-append text-center">
                    <a
                        id="wrap-max"
                        class="text-green-gradient max-button-style"
                        href="#"
                        @click="maxWrap"
                        >MAX</a
                    >
                </div>
            </div>
            <div class="input-group input-group-outline mbo-3 flex-nowrap">
                <span class="wrap-input-placeholder">
                    {{ selectedToken }}
                </span>
                <input
                    type="number"
                    class="form-control mto-1 text-right wrap-form-input"
                    aria-label="Wrap"
                    aria-describedby="basic-addon2"
                    v-model="wrapInput"
                    id="wrap-input-to"
                    readonly
                    min="0"
                />
                <div
                    class="input-group-append text-center"
                    style="z-index: -10;position: relative;opacity: 0;"
                >
                    <a
                        id="wrap-max"
                        class="text-green-gradient max-button-style"
                        href="#"
                        >MAX</a
                    >
                </div>
            </div>
            <div class="row mbo-3">
                <div class="col-12">
                    <button
                        class="btn btn-primary btn-vault-strip"
                        style="width:100% !important;"
                        id="wrap-button"
                        v-if="!loading"
                        @click="wrap"
                        :disabled="disabled"
                    >
                        Wrap {{ tokenText }} to {{ selectedToken }}
                    </button>
                    <div
                        v-else
                        style="display: flex;align-items: center;margin-left: 2em; justify-content:center"
                    >
                        <div class="text-green-gradient">
                            Wrapping {{ tokenText }} to {{ selectedToken }}
                        </div>
                        <div>&nbsp;</div>
                        <div
                            style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                        >
                            <div class="dot-falling"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props:{
        vault:{
            type:Object
        }
    },
    data() {
        return {
            wrapInput: null,
            loading:false,
            disabled:true,
        };
    },
    methods: {
        maxWrap() {
            this.wrapInput = this.wallet.baseBalance;
        },
        async wrap(){
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );
            if (token == undefined) return;

            this.loading = true;

            let payload = {
                amount: this.wrapInput,
                token_contract: token.contract,
                abiType: this.vault.type,
                maxWrap: this.wallet.baseBalance,
                token: token,
            };

            try {
                if(this.walletProvider == "walletconnect") {
                    this.$store.dispatch("vaults/wrap", payload)
                    .then((response) => {
                        console.log('Received txHash: ', response);
                        if (response) {
                            this.$emit("update-vault");
                            this.wrapInput = "";
                            this.loading = false;
                        }
                    })
                    .catch((error) => {
                        Vue.default.toasted.error(error.message);
                        this.loading = false;
                    });
                    return;
                } else {
                    await this.$store.dispatch("vaults/wrap", payload);
                }
            } catch (error) {
                // if user using brave wallet & reject the request
                if ((navigator.brave && await navigator.brave.isBrave() || false) && error.code === -32602 && error.message == "User rejected the transaction") {
                    Vue.default.toasted.error("User rejected the request");
                    this.loading = false
                    return;
                }

                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = '0x0';
                    await this.$store.dispatch("vaults/wrap", payload);
                }
            }

            // this.$emit("update-vault");

            (this.wrapInput = null), (this.loading = false);
        }
    },
    computed: {
        ...mapState(["wallet"]),
        tokenText() {
            if (this.wallet.tokenText)
                return this.wallet.tokenText.toUpperCase();
            else return;
        },
        selectedToken() {
            if (this.wallet.selectedToken)
                return this.wallet.selectedToken.toUpperCase();
            else return;
        }
    },
    watch:{
        wrapInput(v,o){
            const splitValue = v.split('.');
            const token = this.wallet.tokens.find(item => item.symbol == this.vault.real_token_symbol && item.network == this.vault.network);

            const decimalPlaces = (splitValue[1]).length; // count decimal places
            if(decimalPlaces > token.decimals.toString().length - 1) this.wrapInput = o // compare inputed amount decimal with token decimal

            if(+v > +this.wallet.baseBalance || +v <= 0) this.disabled = true;
            else this.disabled = false;
        }
    }
};
</script>
